module.exports = __webpack_public_path__ + "static/img/3.315ec3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.jpg
// module id = 46
// module chunks = 1 4